import React from "react";
import PostDetails from "../features/PostDetals/PostDetails";

export default function Post() {
  return <PostDetails></PostDetails>;
}
